///
/// EarthBrowser
///
/// Migration v52 to v53: Add synoptic sub-layer datasets
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///

interface StateV52 {
	earthbrowser?: {
		visibleDatasets?: string[]
	}
}

/**
 * Migration: v52 to v53
 *
 * Changes:
 * - Adds the "fronts", "jetstream" and "upper_air" dataset types as
 *   sub-layers of "synoptic" (weather fronts; 250 hPa jet stream and
 *   500 hPa height contours on their own shells). Fronts and jet default
 *   on: like the other parent/child pairs (radar/nexrad,
 *   location/city_weather) they only render while the parent is visible,
 *   so adding them doesn't change what users currently see. The 500 hPa
 *   contours are a specialist view and default off.
 */
export function migrateV52toV53(state: unknown): unknown {
	const s = state as StateV52
	const visible = s.earthbrowser?.visibleDatasets
	if (s.earthbrowser && Array.isArray(visible)) {
		for (const type of ["fronts", "jetstream"]) {
			if (!visible.includes(type)) visible.push(type)
		}
	}
	return state
}
